import axios from "axios";

const API_URL = import.meta.env.VITE_APP_API_URL;

export interface NMPClassificationSubCategory {
	id: number;
	name: string;
	code: string | null;
}

export interface NMPClassificationCategory {
	id: number;
	name: string;
	sub_categories: NMPClassificationSubCategory[];
}

export interface NMPClassification {
	id: number;
	name: string;
	categories: NMPClassificationCategory[];
}

export interface NMPClassificationTree {
	classifications: NMPClassification[];
}

// Live tree of classification -> category -> sub-category for a scheme's
// Observations steps, scoped to that scheme's own mapped categories via
// scheme_issue_mappings. A classification/category with no resulting
// sub-categories is omitted by the backend, so this is always exactly as
// long as the scheme's real mapped data.
export const fetchSchemeClassificationTree = async (
	schemeId: number | string,
): Promise<NMPClassificationTree> => {
	const response = await axios.get(
		`${API_URL}/admin/scheme-issue-mapping/classification-tree`,
		{ params: { scheme_id: schemeId } },
	);
	return response.data?.data ?? { classifications: [] };
};
